module.exports = __webpack_public_path__ + "assets/img/brand-06.b5cdc851.png";